import { Helmet } from "react-helmet-async";

/**
 * Emits an ItemList of schema.org Event objects for the events currently
 * rendered on the homepage. Search engines use this to display Rich Results
 * (event carousels in Google search).
 *
 * We keep it capped at 30 events to stay under Google's practical limit and
 * avoid bloating the initial HTML payload.
 */
export default function EventsSchema({ events }) {
  if (!events || events.length === 0) return null;

  const items = events.slice(0, 30).map((e, i) => {
    const ev = {
      "@type": "Event",
      name: e.title,
      startDate: e.start_datetime,
      endDate: e.end_datetime || undefined,
      eventStatus: "https://schema.org/EventScheduled",
      eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
      description: e.description || undefined,
      image: e.image_url || undefined,
      url: e.source_url || undefined,
      location: {
        "@type": "Place",
        name: e.venue || e.town || "Southern Maine",
        address: {
          "@type": "PostalAddress",
          addressLocality: e.town || "Portland",
          addressRegion: "ME",
          addressCountry: "US",
        },
      },
      offers: e.is_paid
        ? {
            "@type": "Offer",
            url: e.source_url || undefined,
            availability: "https://schema.org/InStock",
            priceCurrency: "USD",
          }
        : {
            "@type": "Offer",
            price: "0",
            priceCurrency: "USD",
            availability: "https://schema.org/InStock",
          },
    };
    return {
      "@type": "ListItem",
      position: i + 1,
      item: ev,
    };
  });

  const jsonld = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: items,
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonld)}</script>
    </Helmet>
  );
}
